// ===================================================
// ФАЙЛ: frontend/src/services/productGroups.js
// Сервис для работы с группами вариативных товаров
// Ошибки пробрасываются к вызывающему коду (axios / interceptors).
// ===================================================

import axios from '../utils/axios';
import { API_ENDPOINTS } from '../utils/constants';

export const getProductGroups = async (params = {}) => {
  const response = await axios.get(API_ENDPOINTS.PRODUCT_GROUPS, { params });
  return response.data;
};

export const getProductGroup = async (groupId) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_DETAILS.replace(':id', groupId);
  const response = await axios.get(url);
  return response.data;
};

export const createProductGroup = async (groupData) => {
  const response = await axios.post(API_ENDPOINTS.PRODUCT_GROUPS, groupData);
  return response.data;
};

export const updateProductGroup = async (groupId, groupData) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_DETAILS.replace(':id', groupId);
  const response = await axios.put(url, groupData);
  return response.data;
};

export const deleteProductGroup = async (groupId) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_DETAILS.replace(':id', groupId);
  const response = await axios.delete(url);
  return response.data;
};

export const getGroupVariations = async (groupId) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_VARIATIONS.replace(':id', groupId);
  const response = await axios.get(url);
  return response.data;
};

export const addProductToGroup = async (groupId, productData) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_ADD_VARIATION.replace(':id', groupId);
  const response = await axios.post(url, productData);
  return response.data;
};

export const removeProductFromGroup = async (groupId, productId) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_REMOVE_VARIATION
    .replace(':id', groupId)
    .replace(':productId', productId);
  const response = await axios.delete(url);
  return response.data;
};

export const reorderGroupVariations = async (groupId, order) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_REORDER_VARIATIONS.replace(':id', groupId);
  const response = await axios.post(url, { order });
  return response.data;
};

export const suggestSimilarProducts = async (productId, params = {}) => {
  const url = API_ENDPOINTS.PRODUCT_GROUP_SUGGEST_SIMILAR.replace(':productId', productId);
  const response = await axios.get(url, { params });
  return response.data;
};

export const createGroupFromProducts = async (data) => {
  const response = await axios.post(API_ENDPOINTS.PRODUCT_GROUP_CREATE_FROM_PRODUCTS, data);
  return response.data;
};

export const autoAnalyzeVariations = async (params = {}) => {
  const response = await axios.post(API_ENDPOINTS.PRODUCT_GROUP_AUTO_ANALYZE, params);
  return response.data;
};

export const mergeSelectedProducts = async (data) => {
  const response = await axios.post(API_ENDPOINTS.PRODUCT_GROUP_MERGE_SELECTED, data);
  return response.data;
};

export const getMergeHistory = async (params = {}) => {
  const response = await axios.get(API_ENDPOINTS.PRODUCT_GROUP_MERGE_HISTORY, { params });
  return response.data;
};

const productGroupsService = {
  getProductGroups,
  getProductGroup,
  createProductGroup,
  updateProductGroup,
  deleteProductGroup,
  getGroupVariations,
  addProductToGroup,
  removeProductFromGroup,
  reorderGroupVariations,
  suggestSimilarProducts,
  createGroupFromProducts,
  autoAnalyzeVariations,
  mergeSelectedProducts,
  getMergeHistory
};

export default productGroupsService;
